import "./styles.scss";

import classnames from "classnames";

import { useApp } from "context/app";

import Button from "components/Button";
import AnimatedGradient from "components/AnimatedGradient";

import useResponsive from "libs/helpers/useResponsive";
import gradient_props from "libs/gradient_props";

const mainClass = "placeholder-page";

const PlaceholderPage = ({
  id,
  title,
  text,
  button,
  color,
  variant,
  event,
}) => {
  const { theme } = useApp();
  const { min } = useResponsive();

  const { time, seed, colors } = gradient_props[color ?? "blue"];

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${variant}`]: !!variant,
        [`${mainClass}--${color}`]: !!color,
      })}
    >
      <div className={`${mainClass}__wrapper`}>
        <h1>{title}</h1>
        <p>{text}</p>
        {!!Array.isArray(button) ? (
          <div className={`${mainClass}__wrapper__buttons`}>
            {button?.map(({ label, href, size, variant }, index) => (
              <Button
                key={index}
                size={size ? (size !== "DEFAULT" ? size : undefined) : "large"}
                href={href}
                variant={variant ?? "transparent-white"}
              >
                {label}
              </Button>
            ))}
          </div>
        ) : (
          !!button?.label && (
            <Button
              href={button?.href}
              variant={button?.variant ?? "transparent-white"}
              onClick={!!event ? event : null}
            >
              {button.label}
            </Button>
          )
        )}
      </div>
      <div className={`${mainClass}__background`}>
        {min.sm && (
          <AnimatedGradient
            id={`placeholder-gradient-${id}`}
            time={time}
            seed={seed}
            colors={colors[theme]}
          />
        )}
      </div>
    </div>
  );
};

export default PlaceholderPage;
